import { request } from '../core';
import { Method } from '../core/util';
export interface IssueRequest {
  issueNumber: string;
  acceptUsername?: string;
  cockpitNumber?: string;
  /** 转单/抛单/结单：正常流程传 true；受理挂起传 false */
  acceptNewIssue?: boolean;
  reminderUsername?: string;
  forceClose?: boolean;
  eventCount?: number;
}
export default class IssueApi {
  /** 派单 */
  public allocateIssue = async (params: IssueRequest) => {
    const { issueNumber, cockpitNumber } = params;
    const requestOptions: RequestOptions = {
      path: '/ticket/operate/allocate',
      method: Method.POST,
      body: {
        issueNumber: issueNumber,
        cockpitNumber: cockpitNumber,
      },
    };
    return request(requestOptions);
  };

  /** 受理工单 */
  public acceptIssue = async (params: IssueRequest) => {
    const { issueNumber, acceptUsername, cockpitNumber } = params;
    const requestOptions: RequestOptions = {
      path: '/ticket/operate/accept',
      method: Method.POST,
      body: {
        issueNumber: issueNumber,
        acceptUsername: acceptUsername,
        cockpitNumber: cockpitNumber,
      },
    };
    return request(requestOptions);
  };

  /** 转单 */
  public transferIssue = async (params: IssueRequest) => {
    const { issueNumber, cockpitNumber, acceptNewIssue } = params;
    const requestOptions: RequestOptions = {
      path: '/ticket/operate/transfer',
      method: Method.POST,
      body: {
        issueNumber: issueNumber,
        cockpitNumber: cockpitNumber,
        acceptNewIssue: acceptNewIssue,
      },
    };
    return request(requestOptions);
  };

  /** 抛单 */
  public discardIssue = async (params: IssueRequest) => {
    const { issueNumber, acceptNewIssue } = params;
    const requestOptions: RequestOptions = {
      path: '/ticket/operate/discard',
      method: Method.POST,
      body: {
        issueNumber: issueNumber,
        acceptNewIssue: acceptNewIssue,
        cockpitType: 'MONITOR_SEAT',
      },
    };
    return request(requestOptions);
  };

  /** 挂单 */
  public holdIssue = async (params: IssueRequest) => {
    const { issueNumber } = params;
    const requestOptions: RequestOptions = {
      path: '/ticket/operate/on-hold',
      method: Method.POST,
      body: {
        issueNumber: issueNumber,
      },
    };
    return request(requestOptions);
  };

  /** 取消挂单 */
  public cancelHoldIssue = async (params: IssueRequest) => {
    const { issueNumber } = params;
    const requestOptions: RequestOptions = {
      path: '/ticket/operate/cancel-on-hold',
      method: Method.POST,
      body: {
        issueNumber: issueNumber,
      },
    };
    return request(requestOptions);
  };

  /** 催单 */
  public remindIssue = async (params: IssueRequest) => {
    const { issueNumber, reminderUsername } = params;
    const requestOptions: RequestOptions = {
      path: '/ticket/operate/remind',
      method: Method.POST,
      body: {
        issueNumber: issueNumber,
        reminderUsername: reminderUsername,
      },
    };
    return request(requestOptions);
  };

  /** 结单 */
  public completeIssue = async (params: IssueRequest) => {
    const { issueNumber, acceptNewIssue, forceClose, eventCount } = params;
    const requestOptions: RequestOptions = {
      path: '/ticket/operate/complete',
      method: Method.POST,
      body: {
        issueNumber: issueNumber,
        acceptNewIssue: acceptNewIssue,
        forceClose: forceClose,
        eventCount: eventCount,
      },
    };
    return request(requestOptions);
  };

  /** 查询车辆当日工单列表 */
  public getVehicleIssues = async (vehicleName: string) => {
    const requestOptions: RequestOptions = {
      path: '/ticket/query/get-issues/vehicle',
      method: Method.POST,
      body: {
        vehicleName: vehicleName,
      },
    };
    return request(requestOptions);
  };

  /** 查询工单操作记录 */
  public getIssueOperation = async (params: IssueRequest) => {
    const { issueNumber } = params;
    const requestOptions: RequestOptions = {
      path: '/ticket/query/issue-operation',
      method: Method.POST,
      body: { issueNumber: issueNumber },
    };
    return request(requestOptions);
  };

  /** 查询工单关联事件 */
  public getIssueEvent = async (params: IssueRequest) => {
    const { issueNumber } = params;
    const requestOptions: RequestOptions = {
      path: '/ticket/query/issue-event',
      method: Method.POST,
      body: { issueNumber: issueNumber },
    };
    return request(requestOptions);
  };

  /** 检查当前车辆是否有工单 */
  public getVehicleIssue = async (params: { vehicleName: string }) => {
    const requestOptions: RequestOptions = {
      path: '/ticket/query/vehicle-has-issue',
      method: Method.POST,
      body: params,
    };
    return request(requestOptions);
  };

  /** 获取人工记录列表 */
  public getManualAlarmList = async (vehicleName: string) => {
    const requestOptions: RequestOptions = {
      path: '/monitor/web/alarm/listTodayManualAlarm',
      method: Method.POST,
      body: {
        vehicleName: vehicleName,
      },
    };
    return request(requestOptions);
  };

  /** 获取可转单座席明细列表 */
  public getTransferCockpitList = async (
    cockpitTeamNumber: string,
    vehicleName: string,
  ) => {
    const requestOptions: RequestOptions = {
      path: '/monitor/web/cockpitTeam/getAllowIssueCockpitList',
      method: Method.POST,
      body: {
        cockpitTeamNumber,
        vehicleName,
      },
    };
    return request(requestOptions);
  };

  /** 查询座席团队当日工单列表 */
  public getCockpitTeamIssueList = async (cockpitTeamNumber: string) => {
    const requestOptions: RequestOptions = {
      path: '/ticket/query/get-issues/cockpit-team',
      method: Method.POST,
      body: {
        cockpitTeamNumber: cockpitTeamNumber,
      },
    };
    return request(requestOptions);
  };

  fetchVideoUrl = (vehicleName: string) => {
    const requestOptions: RequestOptions = {
      path: `/monitor/web/video/url`,
      method: Method.POST,
      body: {
        vehicleName,
      },
    };
    return request(requestOptions);
  };

  cancelNewIssue = (issueNumbers: string[], cockpitNumber: string) => {
    const requestOptions: RequestOptions = {
      path: '/ticket/operate/issue/pop-up',
      method: Method.POST,
      body: { issueNumbers, cockpitNumber },
    };
    return request(requestOptions);
  };
}
